<template>
  <div class="home">
    <!-- header -->
    <HeaderComponent screenName="complySync"/>
    <!-- banner -->
    <BannerComponent
      :imageSrc="bannerImgUrl"
      :bannerHeadingColor="bannerHeadingColor"
      :isOverlay="false"
      heading="Navigate Compliance, Instill Confidence"
      subheading="AI/ML Document Intelligence for ATO"
    />
    <!-- benefitis -->
    <div class="modernization-sub-heading" style="background-color: #fff;" data-aos="fade-up">
      <h1>WHO BENEFITS</h1>
      <v-row class="justify-center ma-5 mb-8">
        <v-col
          v-for="(item, index) in cardItems"
          :key="index"
          style="justify-content: center; display: grid;"
        >
          <v-card
            class="card"
            :style="`background-color: ${item.color};`"
            elevation="0"
          >
            <div class="card-content">
              <img
                :src="require(`@/assets/solutions/comply-sync/icons/${item.imgUrl}`)"
                alt="card-image"
              >
            </div>
          </v-card>
          <h3 class="card-heading mt-7 mb-5">{{ item.heading }}</h3>
        </v-col>
      </v-row>
    </div>
    <!-- working diagram -->
    <div class="modernization-sub-heading" data-aos="fade-up">
      <h1>HOW IT WORKS</h1>
      <v-container class="d-flex justify-center">
        <v-img
          :src="require('@/assets/solutions/comply-sync/ComplySyncATO diagram.png')"
          alt="ComplySync"
          class="responsive-image"
          max-width="100%"
        ></v-img>
      </v-container>
    </div>
    <!-- features -->
    <div class="modernization-sub-heading" data-aos="fade-up">
      <h1>FEATURES</h1>
      <v-row class="justify-center align-center" style="padding: 30px;max-width: 100%;">
        <v-col
          cols="12"
          md="12"
          lg="6"
          v-for="(colItems, colIndex) in splitItems"
          :key="colIndex"
          class="feature-col-item"
          :style="colIndex === 0 ? '' : 'margin-left: -17px;'"
        >
          <h3
            v-for="(item, index) in colItems"
            :key="index"
            class="feature-item d-flex"
          >
            <span class="mr-2">•</span> {{ item }}
          </h3>
        </v-col>
      </v-row>
    </div>
    <SectionComponent
      relatedTitle="IMPLEMENTATION OPTIONS"
      paragraphContent=""
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
      :showHeading="false"
      :backgroundImage="false"
      :backgroundCard="true"
      customerSectionBackground=""
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      bannerImgUrl: 'solutions/comply-sync/pexels-deepmind.jpg',
      bannerHeadingColor: '#000',
      featureItems: [
        'Compliance with the latest RMF 2.0, NIST 800-53 Rev.5',
        'Automatic Validation on DISA STIG Manual Findings',
        'Applicable to Any System - On-premise or Cloud',
        'Available as On-premise implementation of SaaS',
        'Smart Filtering of Applicable Control Responses',
        'Actionable Analytics on Control Families',
        'Interfaces for Existing GRC Implementations',
        'Invertebrates with Security Scanning Results',
        'Locally Analyzes and Locally Stores',
        'Traffic Never Leaves Customer Network',
        'Data Provenance, Audit History, and Traceability',
        'CI/CD Pipeline Integration',
        'Automatic Predefined Control Implementation',
        'Containerized Infrastructure',
        'Zero-trust Security and IdM Integrated',
        'Automatic POA&M Export of Non-Compliant Controls'
      ],
      cardItems: [
        {
          'heading': 'CISO/ISSO',
          'imgUrl': 'user-security.png',
          'color': '#7594FE'
        },
        {
          'heading': 'System Owners',
          'imgUrl': 'person-star.png',
          'color': '#50E1FE'
        },
        {
          'heading': 'App Dev Teams',
          'imgUrl': 'code.png',
          'color': '#E2BF66'
        },
        {
          'heading': 'Compliance Teams',
          'imgUrl': 'compliance.png',
          'color': '#FF922E'
        },
        {
          'heading': 'DevSecOps Teams',
          'imgUrl': 'infinity.png',
          'color': '#6EA3FF'
        }
      ],
      sectionContents: [
        '“The team was instrumental in enhancing the CMS ATO process and implemented ISPG’s Security Data Lake (SDL) platform and integrating it with the Continuous Diagnostic and Monitoring (CDM) data sources from AWS for establishing a consolidated view of the security posture of all FISMA systems. The team utilized the Agile Development Framework and established a CI/CD pipeline to successfully design, develop and build the SDL. The team successfully applied Human Centered Design (HC) while developing various SDL dashboards increasing the usability and accessibility and overall adoption.”',
        '“The team has successfully performed numerous complex security related engineering tasks well over hte life of the system, and successfully met the SEC CISO ATO mandates including the encryption of SEC data in transit and at rest, for mission critical systems. The team implemented file level encryption end to end form submission, processing, storage, and dissemination, protecting SEC’s High Value Assets (HVA).”',
      ],
      additionalContent: [
        'CMS, CO', 
        'SEC, Assistant Director', 
      ],
      cardData: [
         {
          className: 'advisory-services',
          color: '#7594FE',
          heading: 'Consulting and Advisory Services',
          link: ''
        },
        {
          className: 'project',
          color: '#50E1FE',
          heading: 'Enhance scope of an existing project',
          link: ''
        },
        {
          className: 'complysync',
          color: '#E2BF66',
          heading: 'ComplySync Managed Services',
          link: ''
        },
      ]
    };
  },
  computed: {
    splitItems(){
      const half = Math.ceil(this.featureItems.length / 2);
      return [this.featureItems.slice(0, half), this.featureItems.slice(half)];
    }
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.card{
  height: 230px;
  width: 230px;
  margin: 0;
  border-radius: 50%;
}
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.card-content img{
  border-style: none;
  width: 113px;
  height: 113px;
}
.card-heading{
  font-size: 27px;
  justify-content: center;
  display: flex;
  font-weight: 300;
}
.feature-col-item{
  justify-content: center; 
  display: grid;
}
@media (max-width: 1280px) {
  .feature-col-item{
    margin-top: -25px;
  }
}
.feature-item{
  font-size: 23px;
  font-weight: 400;
}
.responsive-image {
  max-width: 100%;
  height: auto;
}
.modernization-sub-heading{
  background-color: #F0F2F2;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.modernization-sub-heading h1{
  margin-top: 40px;
  /* margin-bottom: 20px; */
  color: #336FE5;
  font-size: 40px;
  text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.3);
  justify-content: center;
  display: flex;
}
@media (max-width: 1350px) {
  .modernization-sub-heading h1{
    margin-top: 35px;
    font-size: 38px;
  }
}
@media (max-width: 1100px) {
  .modernization-sub-heading h1{
    margin-top: 30px;
    font-size: 36px;
  }
}
@media (max-width: 955px) {
  .modernization-sub-heading h1{
    margin-top: 25px;
    font-size: 34px;
  }
  .feature-item{
    font-size: 21px;
  }
}
@media (max-width: 800px) {
  .modernization-sub-heading h1{
    margin-top: 20px;
    font-size: 32px;
  }
  .feature-item{
    font-size: 19px;
  }
}
@media (max-width: 650px) {
  .modernization-sub-heading h1{
    margin-top: 15px;
    font-size: 30px;
  }
  .feature-item{
    font-size: 17px;
  }
}
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>